export default __webpack_public_path__ + "static/media/market3.67451b19.png";